import { StyleSheet, View, Text, ImageBackground } from "react-native";
import SimplePress from "./SimplePress";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { getSchemeStyle } from "../context/helper";
import { MaterialIcons } from "./VectorIcons";

const PageHeader = ({ navigation, showBack }) => {
  const schemeStyles = getSchemeStyle();
    
  const { userInfo, useFirmName, isService } = useContext(AuthContext);
  return (
    <View style={styles.headerContainer}>
      {showBack && (
        <SimplePress
          onPress={() => navigation.goBack()}
          style={[styles.backButton,schemeStyles.BorderC]}
        >
          <MaterialIcons name="arrow-back-ios" size={30} color={schemeStyles.grayIcon.color} />
        </SimplePress>
      )}
      <View style={styles.headerTextContainer}>
        <Text style={[styles.headerText,schemeStyles.defaultText]}>Sencono - Temperaturkontrolle</Text>
        {useFirmName.current&&
        <Text style={[styles.headerSmallText,schemeStyles.defaultText]}>{useFirmName.current}</Text>}
        <Text style={[styles.headerSmallText,schemeStyles.defaultText]}>Benutzer: {userInfo.current.username}</Text>
      </View>
      <SimplePress onPress={() => navigation.openDrawer()} disabled={isService}>
        <ImageBackground
          source={require("../assets/images/sencono-logo-256.png")}
          style={styles.profileImage}
        />
      </SimplePress>
    </View>
  );
};

export default PageHeader;

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: "row",
    marginBottom: 20,
    paddingHorizontal: 10,
    alignItems: "center",
  },
  headerTextContainer: {
    flex: 1,
  },
  headerText: {
    fontSize: 18,
    fontFamily: "Roboto-Medium",
  },
  headerSmallText: {
    fontSize: 12,
    fontFamily: "Roboto-Medium",
  },
  profileImage: {
    width: 45,
    height: 45,
    marginRight: 10
  },
  backButton: {
    marginRight: 5,
    width: 40,
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: 10,
  },
});
